<template>
	<div class="congrats">
		<b-modal
			class="congrats-modal"
			content-class="congrats-main-modal-content"
			v-model="show"
			centered
			size="xl"
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="congrats-modal-content">
				<div
					class="modal-content-item"
					:class="congratsData.category == 'reward redeemed' ? 'reward-redeemed-item' : ''"
				>
					<div v-if="congratsData.category != 'reward redeemed'" class="content-item-style">
						<img src="@/assets/background/bg-lines.svg" />
						<img class="content-item-style-confetti-bg" src="@/assets/background/bg-congrats-2.svg" />
						<div class="white-gradient"></div>
					</div>
					<img 
					v-if="congratsData.category == 'reward redeemed'"
					class="redeemed-style-confetti-bg" 
					src="@/assets/background/bg-congrats-3.svg" />
					
					<div class="item-container">
						<div v-if="congratsData.category == 'reward redeemed'" class="reward-redeemed-style">
							<div class="redeemed-style-badge">
								<img src="@/assets/button-style/congrats-badge.png" />
								<label class="badge-text">YOU DID IT!</label>
								<label class="under-badge-text">YOU HAVE REDEEMED A NEW REWARD</label>
							</div>
						</div>
						<div class="item-content">
							<img  :src="congratsData.icon" class="item-icon" />
							<label v-if="!congratsData.img" class="item-icon-title">{{ congratsData.title }}</label>
							<label v-if="congratsData.level" class="item-icon-level">{{congratsData.level}}</label>
							<img v-if="congratsData.img" :src="congratsData.img" class="item-image" />
							<label v-if="congratsData.img" class="item-image-title">{{ congratsData.title }}</label>
							<b-button class="text-capitalize congrat-item-button" @click="nextCongrats">Continue</b-button>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
const starIcon = require("@/assets/icons/icon-stars.svg");
const challengeCompletedIcon = require("@/assets/icons/icon-challenge-completed.png");
const levelUpIcon = require("@/assets/icons/icon-level-up.png");

// const rewardRedeemedIcon = require("@/assets/button-style/congrats-badge.png");
// const congratsBackground = require("@/assets/background/bg-congrats-2.svg");

export default {
	data() {
		return {
			show: false,
			congratsData: {
				icon: starIcon,
				title: "New stars earned",
				category: "stars",
			},
			congratsQueue: []
			// congrats: [
			// 	{
			// 		id: 0,
			// 		icon: starIcon,
			// 		title: "New stars earned",
			// 		category: "stars",
			// 	},
			// 	{
			// 		id: 1,
			// 		icon: levelUpIcon,
			// 		title: "Level up 4",
			// 		category: "level up",
			// 	},
			// 	{
			// 		id: 3,
			// 		icon: challengeCompletedIcon,
			// 		title: "Challenge completed",
			// 		category: "challenge completed",
			// 	},
			// 	{
			// 		id: 4,
			// 		icon: levelUpIcon,
			// 		title: "Basketball with dad",
			// 		category: "reward redeemed",
			// 	},
			// ],
		};
	},
	watch: {
		congratsQueue: function () {
			this.show = false
			if ( this.congratsQueue&&this.congratsQueue.length>0 ){
				this.congratsData = this.congratsQueue[0]
				this.show = true
			} 
		},
	},
	methods: {
		nextCongrats() {
			this.congratsQueue.shift()
		}
	},
	computed:{
		...mapGetters("user", [
      "getUserLevel",
    ]),
	},
	mounted(){
		// this.$root.$on('showCongrats', (show = false) => {
		// 	this.show = show
		// })
		this.$root.$on('showChallengeCompleteCongrats', () => {
			this.congratsQueue = [...this.congratsQueue, {
					icon: challengeCompletedIcon,
					title: "Challenge completed",
					category: "challenge completed",
				}]
		})

		// this.$root.$on('showLevelUpCongrats', () => {
		// 	this.congratsQueue = [...this.congratsQueue, {
		// 			icon: levelUpIcon,
		// 			title: "Level up 4",
		// 			category: "level up",
		// 		}]
		// })

		this.$root.$on('showRewardClaimedCongrats', (message,image) => {
			this.congratsQueue = [...this.congratsQueue, {
					title: message,
					category: "reward redeemed",
					icon: null,
					img: image
				}]
		})

		this.$root.$on('showComplexCongrats', (notificationIds, key) => {
			let storedCongratsData = localStorage.getItem('careCongratsDataControl');
			storedCongratsData = storedCongratsData ? JSON.parse(storedCongratsData) : null

			const storedNotificationIds = (
				storedCongratsData && 
				storedCongratsData[key] && 
				storedCongratsData[key].length > 0
				) ? storedCongratsData[key] : []
			let newNotificationIdsList = null

			// case 1
			if (
				storedNotificationIds.length === 0 && 
				notificationIds && 
				notificationIds.length > 0
			) {
				newNotificationIdsList = [...notificationIds]
			}

			// case 2
			if (
				storedNotificationIds.length > 0 && 
				notificationIds && 
				notificationIds.length > 0 && 
				notificationIds.filter(n => !storedNotificationIds.includes(n)).length > 0
			) {
				newNotificationIdsList = [...notificationIds, ...storedNotificationIds]
			}

			if (newNotificationIdsList && newNotificationIdsList.length > 0) {
				
				if ( key == 'newStars')
				this.congratsQueue = [...this.congratsQueue, {
					icon: starIcon,
					title: "New stars earned",
					category: "stars",
				}]

				if ( key == 'levelUp') {
					this.congratsQueue = [...this.congratsQueue, {
						icon: levelUpIcon,
						title: "Level up ",
						level: this.getUserLevel,
						category: "level up",
					}]
				}
			
				const object = storedCongratsData?storedCongratsData:{}
				object[key]= newNotificationIdsList
				localStorage.setItem('careCongratsDataControl',JSON.stringify(
					object
				));
			}

		})
	}
};
</script>

<style lang="scss">

.congrats-main-modal-content{
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}
.congrats {
	.modal-content{
		background-color: red !important;
		
	}
}

</style>

<style scoped lang="scss">
* {
	position: relative;
	margin: 0;
	padding: 0;
	text-transform: uppercase;
}

.congrats-modal {
	background-color: violet;
}



.congrats-modal-content {
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	justify-content: space-evenly;
	align-items: center;
	height: 90vh;

}

.modal-content-item {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

	.redeemed-style-confetti-bg{
		position: absolute;
	}

	.congrat-item-button {
		background: #4fb589;
		font-size: 0.7rem;
		line-height: 0.7rem;
		padding: 0.7rem 1rem;
		border: none;
		border-radius: 100px;
	}

	.content-item-style {
		left: 0;
		top: 0;
		position: absolute;
		width: 100%;
		height: 100%;
		border-radius: 20px;
		background-color: #ffffff;

		display: flex;
		justify-content: center;
		align-items: center;
		* {
			position: absolute;
			width: 100%;
		}

		.content-item-style-confetti-bg{
			width: 90%;
		}

		.white-gradient {
			background: rgb(255, 255, 255);
			background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
			height: 100%;
			border-radius: 20px;
		}
	}
}

.item-container {
	display: flex;
	width: 250px;
	height: 280px;
	min-height: 280px;

	.item-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		height: 100%;
		width: 100%;
		padding: 1rem;
		border-radius: 20px;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);

		.item-icon {	
			height: 100px;
			object-fit: contain;
		}

		& > .item-icon-title, & > .item-icon-level {
			color: #253878;
			font-size: 1.2rem;
			text-align: center;
			width: 80%;
			word-break: break-word;
		}

		& > .item-icon-level {
			font-size: 2rem;

		}
	}
}

.reward-redeemed-item {
	justify-content: center;
	width: 370px;
	height: 420px;
	box-shadow: none;

	& > .item-icon {
		width: 110%;
	}

	.item-container {
		height: unset;
		min-height: unset;
	}
	.reward-redeemed-style {
		display: flex;
		justify-content: center;
		position: absolute;
		margin: auto;
		width: 100%;
		height: 100%;

		* {
			position: absolute;
		}

		.redeemed-style-badge {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 80px;
			top: 20px;
			z-index: 300;

			img {
				width: 145%;
			}

			.badge-text {
				color: white;
				font-size: 2.25rem;
				top: 5%;
			}

			.under-badge-text {
				position: relative;
				font-size: 0.65rem;
				font-weight: 600;
				color: #E3455D;
				top: 2.2rem;
			}
		}
	}	
	
	.item-container {

		.item-content {
			padding-top: 120px;
			height: min-content;
			box-shadow: none;
			background-color: #fff;

			border-radius: 20px;
			border: 3px solid #E65E6F;
			z-index: 100;

			.item-icon{
				display: none;
			}

			.item-image-title{
				font-size: 14px;
				font-weight: 600;
				color: #253878;
				width: 100%;
    			word-break: break-word;
				text-align: center;
			}

			.item-image{
				width: 100%;
				height: 100px;
				max-height: 100px;
				object-fit: contain;
			}

			.congrat-item-button {
				background-color: #2DACB6;
			}
		}
	}
}


</style>
